import { useContext } from "react";
import { ActiveArticleContext } from "../../../providers/ActiveArticleProvider";

export function useActiveArticle() {
  const ctx = useContext(ActiveArticleContext);
  if (!ctx) {
    throw new Error(
      "useActiveArticle must be used inside ActiveArticleProvider"
    );
  }
  return ctx;
}
